import request from '@/utils/request';
/**
 * @description 获取省级城市列表
 */
export function getProvinceListApi() {
  return request({
    url: '/admin/merchant/city/region/province/list',
    method: 'get'
  });
}

/**
 * @description 获取市级城市列表
 * @param parentId 省级ID
 */
export function getCityListApi(parentId) {
  return request({
    url: "/admin/merchant/city/region/city/list/".concat(parentId),
    method: 'get'
  });
}